export default __webpack_public_path__ + "static/media/thumb-5.960f447c.png";